import { Box } from "@outschool/backpack";
import { Container } from "@outschool/ui-legacy-component-library";
import React from "react";

import CompareButton, { CancelCompareButton } from "./CompareButton";

interface CompareFooter {
  selectedListings: string[];
  onClickCompare: () => void;
  onClickCancelCompare: () => void;
}

export default function CompareFooter({
  selectedListings,
  onClickCompare,
  onClickCancelCompare,
}: CompareFooter) {
  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        width: "100vw",
        height: "72px",
        zIndex: 11, // MobileFooterTabBar has zIndex = 10, so this needs to be higher
        backgroundColor: "white",
        boxShadow: "0 5px 20px 0 rgb(0, 0, 0, 0.25)",
        padding: "12px 16px",
      }}
    >
      <Container
        sx={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <CancelCompareButton onClickCancel={onClickCancelCompare} />
        <CompareButton
          isComparing={true}
          selectedListings={selectedListings}
          onClickCompare={onClickCompare}
        />
      </Container>
    </Box>
  );
}
